import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-digital-win',
  templateUrl: './digital-win.component.html',
  styleUrls: ['./digital-win.component.scss']
})
export class DigitalWinComponent implements OnInit, AfterViewInit {

  @ViewChild('emailDigitalWinPopup', { static: false }) emailDigitalWinPopupRef: any;
  @ViewChild('phoneDigitalWinPopup', { static: false }) phoneDigitalWinPopupRef: any
  @ViewChild('captureSuccessWithReceipt', { static: false }) captureSuccessWithReceiptRef: any;

  public modalRef!: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  winDetails: any;
  userId: any;
  clicked = false;
  showSurvey = true;
  isPhoneParticipation = false;

  captureAddress = {
    Name: '',
    Email: '',
    Phone: '',
    Address: '',
    PostalCode: '',
    City: ''
  };

  constructor( private modalService: BsModalService,
    private dataService:DataServiceService,
     public translate: TranslateService,
     private router: Router,
     private authService: AuthService,
     private coreService: CoreService,
     private gaService: GaService,

     ) {
      this.winDetails = this.dataService.getWinDetails()
      this.userId = this.authService.getUserId();
  }

  ngOnInit() {
    let sub = this.dataService.callGetPlay()
    if(this.authService.IsLoggedIn()){
      // this.captureAddress.Phone = (parseInt(localStorage.getItem('user'))/111).toString();
      this.isPhoneParticipation = false;
      this.captureAddress.Email = localStorage.getItem('email');
      console.log("===email", this.captureAddress.Email)
    }
    if(localStorage.getItem('surveyTaken') == 'true') {
      this.showSurvey = false;
    }
  }


  ngAfterViewInit() {
    this.modalRef = this.modalService.show(this.emailDigitalWinPopupRef, this.popupConfig);
 
  }


  onSubmitWinWithReceipt(f:any) {
    this.clicked = true;
    const formData = new FormData();

    let data = {
      userId: this.userId,
      userRewardRowKey: this.winDetails ? this.winDetails.userRewardRK : undefined,
      loginType: 0,
      value: this.captureAddress.Email

    }

    

    this.coreService.captureDigitalWin(data).then(response => {

      this.gaService.emitEvent('reward_redeemed', 'reward_redeemed');
      f.submitted = false;
      this.modalRef.hide();
      this.resetWinDetails();
      this.modalRef = this.modalService.show(this.captureSuccessWithReceiptRef, this.popupConfig);
    });

  }
  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  // playAgain() {
  //   this.getPlay();
  // }

  redirectToHome() {
    this.modalRef.hide();
    this.router.navigate([''])
  }

  resetWinDetails() {
    this.captureAddress = {
      Name: '',
      Email: '',
      Phone: '',
      Address: '',
      PostalCode: '',
      City: ''
    };
  }

  surveyTaken() {
    localStorage.setItem('surveyTaken','true')
  }

}
